import {Condition} from "../engine/Condition.js";
import {merchantVariableModule} from "../../merchant-state/MerchantVariableModule.js";
import {evaluateContextTemplate, makeExpressionEvaluator} from "../../TemplateEvaluation.js";

export class ExprCondition extends Condition {
    constructor(...args) {
        super(...args);

        this.attachListener(merchantVariableModule, this.requestReEval);
    }

    evaluate() {
        const evaluateExpr = makeExpressionEvaluator(evaluateContextTemplate());
        const value = evaluateExpr(this.options.value);
        // Cast to a bool, since null means "not able to evaluate"
        return !!value;
    }
}
